// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"s4-z","colorTextValue":"t4-z","swatches":"u4-z","collapseLink":"v4-z","isCollapsed":"w4-z","dropdown":"x4-z","disabled":"y4-z"};